/** Default clientId used in the default tenant - powertools-portal-users */
export const clientId: string = process.env.POWERTOOLS_CLIENT_ID ?? "a80204d0-8ce3-431f-abc2-94fad91ea6cf";
export const POWERTOOLS_API_ROOT_URL: string = "https://powertools-api.360smartnet.com";